<div class="flex flex-col h-full w-full justify-between">

    @if (hasExhaustion.length > 0 && !loading)
    {
    <div class="flex flex-1 items-center justify-center">
        <app-credits-overview variant="exhaustionlayout" [feature]="feature" [featureId]="featureId"
            (resume)="onResume($event)" />
    </div>
    }
    @else{
    <div class="flex flex-col justify-around items-center gap-3 p-6">
        <p class="flex items-center font-bold theme-text text-xl md:text-2xl gap-2 font-bricolage">
            <span>{{ title }}</span>
        </p>
        <p class="text-lg md:text-base text-gray-500 font-bricolage theme-text text-center break-words">
            <span>{{ description }}</span>
        </p>
        @if (actionLabel) {
        <app-button [label]="actionLabel" severity="primary" variant="filled" icon="rotate-ccw" iconSource="lucide"
            (clicked)="action.emit()" />
        }
    </div>
    @if (animationData) {
    <div>
        <div class="relative flex items-center justify-center w-full h-44">
            <div class="relative">
                <app-lottie-animation [animationData]="animationData" [loop]="true" [autoplay]="true"
                    [width]="animationWidth" [height]="animationHeight" containerClass="geo-technical-summary-lottie">
                </app-lottie-animation>
            </div>
        </div>
    </div>
    }
    }

    @if (bottomImageSvg) {
    <div>
        <div class="flex items-center justify-center">
            <i [innerHTML]="bottomImageSvg | sanitizeHtml" class="[&>svg]:w-[500px] [&>svg]:h-[200px] pl-5"></i>
        </div>
    </div>
    }
</div>